import { render, staticRenderFns } from "./aresstats.vue?vue&type=template&id=027e27ea&scoped=true"
import script from "./aresstats.vue?vue&type=script&lang=js"
export * from "./aresstats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027e27ea",
  null
  
)

export default component.exports